import type { TranslationResources } from './en'

export const he: TranslationResources = {
  app: {
    name: 'LogarGo',
    adminConsole: 'מסוף ניהול',
  },
  nav: {
    dashboard: 'לוח בקרה',
    shipments: 'משלוחים',
    statistics: 'סטטיסטיקות',
    shipmentRequests: 'בקשות משלוח',
    draftRequests: 'בקשות טיוטה',
    jobs: 'משימות',
    jobOffers: 'הצעות עבודה',
    smsOptOuts: 'הסרות מ-SMS',
    cargoReturns: 'החזרות מטען',
    mitigationLadder: 'סולם - רשת בטחון',
    accounts: 'חשבונות',
    allAccounts: 'כל החשבונות',
    shippers: 'שולחים',
    freighters: 'מובילים',
    drivers: 'נהגים',
    vehicles: 'רכבים',
    liveTracking: 'מעקב חי',
    verifications: 'אימותים',
    disputes: 'מחלוקות',
    scores: 'דירוגים',
    finance: 'כספים',
    penalties: 'קנסות ופיצויים',
    subscriptions: 'מנויים',
    activeSubscriptions: 'מנויים פעילים',
    plans: 'תוכניות',
    entitlements: 'תוספות',
    campaigns: 'קמפיינים',
    billingControl: 'בקרת חיוב',
    notifications: 'התראות',
    cronJobs: 'משימות מתוזמנות',
    systemHealth: 'תקינות המערכת',
    systemConfiguration: 'הגדרות מערכת',
    settings: 'הגדרות',
  },
  topbar: {
    switchToDark: 'מעבר למצב כהה',
    switchToLight: 'מעבר למצב בהיר',
    notifications: 'התראות',
    profileSettings: 'הגדרות פרופיל',
    logout: 'התנתקות',
    administrator: 'מנהל',
    detach: 'נתק עמוד',
    openNewTab: 'פתח בלשונית חדשה',
    openNewWindow: 'פתח בחלון חדש',
  },
  settings: {
    title: 'הגדרות',
    subtitle: 'נהל את הפרופיל, השפה והמראה שלך.',
    profileSection: 'פרופיל',
    name: 'שם',
    email: 'דוא"ל',
    phone: 'טלפון',
    role: 'תפקיד',
    status: 'סטטוס',
    accountId: 'מזהה חשבון',
    preferencesSection: 'העדפות',
    language: 'שפה',
    languageHelp:
      'מעדכן את locale בחשבון בשרת. תתבצע התנתקות ותוויות enum ייטענו מחדש בהתחברות הבאה.',
    languageChangeTitle: 'שינוי שפה',
    languageChangeConfirm: 'לעבור לממשק ותוויות enum ב{{language}}?',
    languageChangeConfirmHint: 'locale החשבון יעודכן בשרת. תתנתק מהמערכת, כמו באפליקציות הנייד.',
    languageChangeConfirmAction: 'שנה והתנתק',
    languageChangeFailed: 'עדכון השפה נכשל',
    appearance: 'מראה',
    themeMode: 'ערכת נושא',
    lightMode: 'בהיר',
    darkMode: 'כהה',
    languageChanged: 'השפה עודכנה',
    themeChanged: 'ערכת הנושא עודכנה',
    notProvided: 'לא צוין',
  },
  login: {
    subtitle: 'מסוף ניהול',
    emailLabel: 'כתובת דוא"ל',
    emailPlaceholder: 'admin@example.com',
    passwordLabel: 'סיסמה',
    signIn: 'התחברות',
    signingIn: 'מתחבר...',
    requiresAdmin: 'נדרשות הרשאות SYSTEM_ADMIN',
    accessDenied: 'הגישה נדחתה. נדרש תפקיד SYSTEM_ADMIN.',
    loginFailed: 'ההתחברות נכשלה. נסה שוב.',
    copyright: '© {{year}} LogarGo. פלטפורמת התאמת שולחים-מובילים.',
  },
  languages: {
    EN: 'אנגלית',
    HE: 'עברית',
    AR: 'ערבית',
    RU: 'רוסית',
  },
}
